import type { IExercise } from '../exercises';

export const ARCHIVED_ARMS_TEACHINGS: IExercise[] = [
  {
    "id": "barbell-bicep-curl",
    "name": "站姿杠铃弯举",
    "bodyPart": "arms",
    "equipment": "barbell",
    "subCategory": "biceps",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "10-12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱二头肌","肱肌"],
    "demoUrl": "/media/gifs/barbell-bicep-curl",
    "videoUrl": "/media/videos/barbell-bicep-curl",
  },
  {
    "id": "kneel-tricep-dip",
    "name": "跪姿肘屈伸",
    "bodyPart": "arms",
    "equipment": "bodyweight",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "10",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["肱三头肌","肘肌"],
    "demoUrl": "/media/gifs/kneel-tricep-dip",
    "videoUrl": "/media/videos/kneel-tricep-dip",
  },
  {
    "id": "supine-cable-tricep",
    "name": "仰卧绳索臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱三头肌","肘肌"],
    "demoUrl": "/media/gifs/supine-cable-tricep",
    "videoUrl": "/media/videos/supine-cable-tricep",
  },
  {
    "id": "seated-cable-curl",
    "name": "坐姿绳索二头弯举",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "biceps",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱二头肌","肱肌"],
    "demoUrl": "/media/gifs/seated-cable-curl",
    "videoUrl": "/media/videos/seated-cable-curl",
  },
  {
    "id": "behind-neck-cable-tricep",
    "name": "颈后绳索臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱三头肌","肘肌"],
    "demoUrl": "/media/gifs/behind-neck-cable-tricep",
    "videoUrl": "/media/videos/behind-neck-cable-tricep",
  },
  {
    "id": "home-bent-tricep-kickback",
    "name": "俯身哑铃臂屈伸",
    "bodyPart": "arms",
    "equipment": "dumbbell",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱三头肌","肘肌"],
    "demoUrl": "/media/gifs/home-bent-tricep-kickback",
    "videoUrl": "/media/videos/home-bent-tricep-kickback",
  },
  {
    "id": "home-seated-behind-neck-tricep",
    "name": "坐姿颈后臂屈伸",
    "bodyPart": "arms",
    "equipment": "dumbbell",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱三头肌","肘肌"],
    "demoUrl": "/media/gifs/home-seated-behind-neck-tricep",
    "videoUrl": "/media/videos/home-seated-behind-neck-tricep",
  },
  {
    "id": "home-dumbbell-curl",
    "name": "哑铃弯举",
    "bodyPart": "arms",
    "equipment": "dumbbell",
    "subCategory": "biceps",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱二头肌","肱肌"],
    "demoUrl": "/media/gifs/home-dumbbell-curl",
    "videoUrl": "/media/videos/home-dumbbell-curl",
  },
  {
    "id": "ksw-lying-extension",
    "name": "仰卧屈伸",
    "bodyPart": "arms",
    "equipment": "bodyweight",
    "subCategory": "triceps",
    "tips": ["仰卧位，大臂固定垂直地面","只动小臂，感受肱三头肌充分收缩"],
    "sets": 3,
    "reps": "15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["肱三头肌","肘肌"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-lying-extension",
    "videoUrl": "/media/videos/ksw-lying-extension",
  },
  {
    "id": "ksw-warmup-biceps-release",
    "name": "二头肌放松",
    "bodyPart": "arms",
    "equipment": "foam-roller",
    "subCategory": "放松",
    "tips": ["泡沫轴放上臂前侧二头肌位置","缓慢滚动，放松紧张的二头和前臂"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-biceps-release",
    "videoUrl": "/media/videos/ksw-warmup-biceps-release",
  },
  {
    "id": "ksw-cable-curl",
    "name": "钢线弯举",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "biceps",
    "tips": ["身体稳定，大臂贴身体两侧","弯举时感受二头肌顶峰收缩，下放控制"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱二头肌","肱肌"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-cable-curl",
    "videoUrl": "/media/videos/ksw-cable-curl",
  },
  {
    "id": "threeway-behind-neck-tricep",
    "name": "颈后臂屈伸",
    "bodyPart": "arms",
    "equipment": "bodyweight",
    "subCategory": "triceps",
    "tips": ["手肘尽量贴近耳朵","下落至小臂平行"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": true,
    "demoUrl": "/media/videos/threeway-behind-neck-tricep",
    "videoUrl": "/media/videos/threeway-behind-neck-tricep",
  },
  {
    "id": "threeway-bench-dip",
    "name": "凳上反屈伸",
    "bodyPart": "arms",
    "equipment": "bodyweight",
    "subCategory": "triceps",
    "tips": ["手肘贴近身体","下放至大臂平行"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": true,
    "demoUrl": "/media/videos/threeway-bench-dip",
    "videoUrl": "/media/videos/threeway-bench-dip",
  },
  {
    "id": "threeway-barbell-skull-crusher",
    "name": "仰卧杠铃臂屈伸",
    "bodyPart": "arms",
    "equipment": "barbell",
    "subCategory": "triceps",
    "tips": ["大臂保持垂直","曲杆杠铃更护肘"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-barbell-skull-crusher",
    "videoUrl": "/media/videos/threeway-barbell-skull-crusher",
  },
  {
    "id": "personal-s1-back-tricep-stretch",
    "name": "背加三头拉伸",
    "bodyPart": "arms",
    "equipment": "bodyweight",
    "subCategory": "back",
    "tips": ["感受背阔肌与三头肌的延展","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-back-tricep-stretch",
    "videoUrl": "/media/videos/personal-s1-back-tricep-stretch",
  },
  {
    "id": "personal-s1-bicep-stretch",
    "name": "二头肌拉伸",
    "bodyPart": "arms",
    "equipment": "bodyweight",
    "subCategory": "arms",
    "tips": ["掌心朝外，感受二头延展","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-bicep-stretch",
    "videoUrl": "/media/videos/personal-s1-bicep-stretch",
  },
  {
    "id": "personal-s2-cable-tricep-pushdown",
    "name": "绳索曲臂下压",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["大臂固定不晃动","感受三头肌收缩"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s2-cable-tricep-pushdown",
    "videoUrl": "/media/videos/personal-s2-cable-tricep-pushdown",
  },
  {
    "id": "personal-s3-supine-dumbbell-curl",
    "name": "仰卧哑铃肩伸位弯举",
    "bodyPart": "arms",
    "equipment": "dumbbell",
    "subCategory": "biceps",
    "tips": ["仰卧肩伸位长头受力更多","控制离心阶段","1热身+3正式组"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s3-supine-dumbbell-curl",
    "videoUrl": "/media/videos/personal-s3-supine-dumbbell-curl",
  },
  {
    "id": "personal-s3-overhead-tricep",
    "name": "单手绳索肩屈位臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["肩屈位长头受力更多","大臂保持稳定","1热身+3正式组"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s3-overhead-tricep",
    "videoUrl": "/media/videos/personal-s3-overhead-tricep",
  },
  {
    "id": "personal-s3-internal-rotation-curl",
    "name": "坐姿绳索内旋位弯举",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "biceps",
    "tips": ["内旋位侧重肱肌","控制动作节奏","1热身+3正式组"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s3-internal-rotation-curl",
    "videoUrl": "/media/videos/personal-s3-internal-rotation-curl",
  },
  {
    "id": "personal-s8-cable-tricep-pushdown",
    "name": "绳索臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["超级组第1个动作·三头","大臂固定不晃动","与绳索弯举交替无休息"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "source": "私教超级组",
    "demoUrl": "/media/gifs/personal-s8-cable-tricep-pushdown",
    "videoUrl": "/media/videos/personal-s8-cable-tricep-pushdown",
  },
  {
    "id": "personal-s8-barbell-supine-standing",
    "name": "仰卧杠铃臂伸站姿弯举",
    "bodyPart": "arms",
    "equipment": "barbell",
    "subCategory": "arms",
    "tips": ["超级组·三头+二头组合","仰卧杠铃臂屈伸接站姿弯举","组间休息90秒"],
    "sets": 3,
    "reps": "10+10",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "source": "私教超级组",
    "demoUrl": "/media/gifs/personal-s8-barbell-supine-standing",
    "videoUrl": "/media/videos/personal-s8-barbell-supine-standing",
  },
  {
    "id": "fanjue-straight-arm-pulldown",
    "name": "绳索直臂下压",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["手臂保持伸直","感受背阔肌长头拉伸"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-straight-arm-pulldown",
    "videoUrl": "/media/videos/fanjue-straight-arm-pulldown",
  },
  {
    "id": "fanjue-supinated-straight-arm-pulldown",
    "name": "反握直臂下压",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["反握增加二头参与","全程控制"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-supinated-straight-arm-pulldown",
    "videoUrl": "/media/videos/fanjue-supinated-straight-arm-pulldown",
  },
  {
    "id": "fanjue-elbow-extension-tricep",
    "name": "肘屈伸",
    "bodyPart": "arms",
    "equipment": "bodyweight",
    "subCategory": "triceps",
    "tips": ["大臂固定","肱三头肌充分收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": true,
    "demoUrl": "/media/gifs/fanjue-elbow-extension-tricep",
    "videoUrl": "/media/videos/fanjue-elbow-extension-tricep",
  },
  {
    "id": "fanjue-kneeling-pushup",
    "name": "跪姿俯卧撑",
    "bodyPart": "arms",
    "equipment": "bodyweight",
    "subCategory": "chest",
    "tips": ["跪姿降低难度","胸部主导发力"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-kneeling-pushup",
    "videoUrl": "/media/videos/fanjue-kneeling-pushup",
  },
  {
    "id": "fanjue-bent-barbell-curl",
    "name": "俯身杠铃弯举",
    "bodyPart": "arms",
    "equipment": "barbell",
    "subCategory": "biceps",
    "tips": ["俯身位弯举","二头峰值收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-bent-barbell-curl",
    "videoUrl": "/media/videos/fanjue-bent-barbell-curl",
  },
  {
    "id": "fanjue-single-arm-cable-tricep",
    "name": "单臂绳索臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["单臂绳索下压","侧重三头外侧头"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-single-arm-cable-tricep",
    "videoUrl": "/media/videos/fanjue-single-arm-cable-tricep",
  },
  {
    "id": "fanjue-straight-bar-tricep",
    "name": "直杆臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["直杆绳索下压","三头整体刺激"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-straight-bar-tricep",
    "videoUrl": "/media/videos/fanjue-straight-bar-tricep",
  },
  {
    "id": "fanjue-cable-hammer-curl",
    "name": "绳索锤式弯举",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "biceps",
    "tips": ["锤式弯举","肱肌+肱桡肌"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-cable-hammer-curl",
    "videoUrl": "/media/videos/fanjue-cable-hammer-curl",
  },
];
